import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';
import { signVisitByPestEmployeeFormValues } from 'api/visitReports/type';

export interface signPeriodReportByPestEmployeeInterface {
  signPeriodReportByPestEmployee: signVisitByPestEmployeeFormValues;
  id: string;
  slug: string;
}

export const signPeriodReportByPestEmployeePost = async ({
  signPeriodReportByPestEmployee,
  id,
  slug,
}: signPeriodReportByPestEmployeeInterface) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.post(
    `/period_report/${slug}/${id}/pest-signature/`,
    {
      ...signPeriodReportByPestEmployee,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};
